import { Injectable } from '@angular/core';
import { AddEmailAddressContent } from '@com-delta-idp/mnx-login-ui';
import { SaveEmailAddressRequest } from '../../models/add-email-address.interface';
import { LoginModalContent } from '../../models/aem';
import { AddEmailAddressHelperService } from '../../services/add-email-address/add-email-address-helper.service';

@Injectable({
  providedIn: 'root'
})
export class AddEmailAddressAdapterService {
  constructor(public helper: AddEmailAddressHelperService) {}

  getAddEmailAddressContent(
    loginAemResponse: LoginModalContent
  ): AddEmailAddressContent {
    return {
      formGroup: this.helper.createForm(),
      formAttributes: this.helper.getFormAttributes(),
      pageContent: this.helper.getPageContent(loginAemResponse),
      isError: false,
      isSuccess: false,
      message: ''
    };
  }

  buildRequestObject(content: AddEmailAddressContent): SaveEmailAddressRequest {
    const email = content.formGroup.controls['email'].value?.value.trim();
    return {
      email,
      formNameSubmitted: content.pageContent.viewName
    };
  }
}
